export function ChatResponseTab() {
  return (
    <div className="text-gray-600">
      <p>Chat Response testing coming soon...</p>
    </div>
  );
}
